import { OnlineStockMessage } from "./OnlineStockMessage";
import { useOnlineStock } from "../../../../hooks/useOnlineStock/useOnlineStock";

type Props = {
  skuId: string;
  stockApiBaseUrl: string;
  stockApiKey: string;
};

export function OnlineStockWithChecking({
  skuId,
  stockApiBaseUrl,
  stockApiKey,
}: Props) {
  const { data, error, isLoading } = useOnlineStock(
    skuId,
    stockApiBaseUrl,
    stockApiKey,
  );

  if (isLoading) {
    return <OnlineStockMessage message={null} busy={true} />;
  }

  if (!error && data) {
    const { availabilityStatus, stockMessage } = data;

    const availableAccordingToOnlineStock =
      availabilityStatus !== "SKU_NOT_AVAILABLE";

    return (
      <OnlineStockMessage
        message={availableAccordingToOnlineStock ? stockMessage : null}
        busy={false}
      />
    );
  }

  // No data or error
  // No data will be found when SWR disabled, such as in Page.stories.tsx
  return (
    <OnlineStockMessage message={"Currently in stock online"} busy={false} />
  );
}
